// extracted by mini-css-extract-plugin
export default {"albumCard":"albums_albumCard__+QWVK","imageWrapper":"albums_imageWrapper__A43ej","overlay":"albums_overlay__Ilb-d","loaderWrapper":"albums_loaderWrapper__S7V59"};